module.exports = __webpack_public_path__ + "static/media/suit-diamonds.5304ed78.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/suit-diamonds.png
// module id = 134
// module chunks = 0